/**
 * @generated SignedSource<<25ff7cde47ce0e64604b02e1c64281e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductCarousel_user" | "FavoritesItemProvider_user">;
  readonly " $fragmentType": "SharedItemTile_user";
};
export type SharedItemTile_user$key = {
  readonly " $data"?: SharedItemTile_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedItemTile_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItemProvider_user"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ],
      "kind": "FragmentSpread",
      "name": "BuyerProductCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f8d2c1f2ad20ee8bd31f69f46d6cff31";

export default node;
